module.exports = __webpack_public_path__ + "img/thumb_29.e94118a1.jpg";